import { render, staticRenderFns } from "./ErrorPlaceholder.vue?vue&type=template&id=019cb632&"
import script from "./ErrorPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ErrorPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports